import {Routes} from '@angular/router';
import {AsmGuard} from './asm.guard';
import {AuthGuard} from './auth.guard';
import {Permission} from './enums/permissions.enum';
import {MainApplicationComponent} from './layout/main-application/main-application.component';
import {PublicApplicationComponent} from './layout/public-application/public-application.component';
import {PermissionGuard} from './permission.guard';
import {WELCOME} from './shared/constants';
import {PageDataResolver} from './shared/resolver/page.resolver';

export const appRoutes: Routes = [
  {
    path: '',
    component: MainApplicationComponent,
    children: [
      {
        path: '',
        data: {pageTitle: 'home.title', documentPageTitle: 'home.title'},
        resolve: {pageData: PageDataResolver},
        canActivate: [AuthGuard, PermissionGuard],
        canActivateChild: [AuthGuard, PermissionGuard],
        loadComponent: () =>
          import('./features/home/pages/home/home.component').then((m) => m.HomeComponent),
      },
    ],
  },
  {
    path: 'orders',
    children: [
      {
        path: 'auth',
        loadComponent: () => import('./features/auth/auth.component').then((m) => m.AuthComponent),
      },
      {
        path: 'clear-session',
        loadComponent: () =>
          import('./features/clear-session/clear-session.component').then(
            (m) => m.ClearSessionComponent,
          ),
      },
      {
        path: '',
        component: MainApplicationComponent,
        children: [
          {
            path: '',
            resolve: {pageData: PageDataResolver},
            canActivate: [AuthGuard, PermissionGuard],
            canActivateChild: [AuthGuard, PermissionGuard],
            loadChildren: () =>
              import('./features/orders/pages/orders-routes').then((m) => m.ordersRoutes),
          },
          {
            path: 'checkout',
            resolve: {pageData: PageDataResolver},
            canActivate: [AuthGuard, PermissionGuard],
            canActivateChild: [AuthGuard, PermissionGuard],
            loadChildren: () =>
              import('./features/checkout/pages/checkout-routes').then((m) => m.checkoutRoutes),
          },
          {
            path: 'cart',
            data: {
              pageTitle: 'cart.title',
              documentPageTitle: 'cart.title',
              permissions: [Permission.COVESTRO_CREATE_STANDARD_ORDER],
            },
            resolve: {pageData: PageDataResolver},
            canActivate: [AuthGuard, PermissionGuard],
            canActivateChild: [AuthGuard, PermissionGuard],
            loadChildren: () =>
              import('./features/cart/pages/cart-routes').then((m) => m.cartRoutes),
          },
        ],
      },
    ],
  },
  {
    path: 'finance',
    component: MainApplicationComponent,
    children: [
      {
        path: '',
        data: {title: 'finance.title'},
        resolve: {pageData: PageDataResolver},
        canActivate: [AuthGuard, PermissionGuard],
        canActivateChild: [AuthGuard, PermissionGuard],
        loadChildren: () =>
          import('./features/finance/pages/finance-routes').then((m) => m.financeRoutes),
      },
    ],
  },
  {
    path: 'support-hub',
    component: MainApplicationComponent,
    children: [
      {
        path: '',
        data: {title: 'support-hub.title'},
        resolve: {pageData: PageDataResolver},
        canActivate: [AuthGuard, PermissionGuard],
        canActivateChild: [AuthGuard, PermissionGuard],
        loadChildren: () =>
          import('./features/inquiry/pages/inquiry-routes').then((m) => m.inquiryRoutes),
      },
      {
        path: 'contacts',
        data: {pageTitle: 'contacts.title', documentPageTitle: 'contacts.title'},
        resolve: {pageData: PageDataResolver},
        canActivate: [AuthGuard, PermissionGuard],
        canActivateChild: [AuthGuard, PermissionGuard],
        loadComponent: () =>
          import('./features/contacts/pages/support-contacts.component').then(
            (m) => m.SupportContactsComponent,
          ),
      },
    ],
  },
  {
    path: 'user',
    component: MainApplicationComponent,
    children: [
      {
        path: 'preferences',
        data: {pageTitle: 'preferences.title', documentPageTitle: 'preferences.title'},
        resolve: {pageData: PageDataResolver},
        canActivate: [AuthGuard, PermissionGuard],
        canActivateChild: [AuthGuard, PermissionGuard],
        loadChildren: () =>
          import('./features/preferences/pages/preferences-routes').then(
            (m) => m.preferencesRoutes,
          ),
      },
      {
        path: 'notification-settings',
        data: {
          pageTitle: 'notificationSettings.title',
          documentPageTitle: 'notificationSettings.title',
        },
        resolve: {pageData: PageDataResolver},
        canActivate: [AuthGuard, PermissionGuard],
        canActivateChild: [AuthGuard, PermissionGuard],
        loadChildren: () =>
          import('./features/notification-settings/pages/notification-settings-routes').then(
            (m) => m.notificationSettingsRoutes,
          ),
      },
    ],
  },
  {
    path: 'asm',
    component: MainApplicationComponent,
    children: [
      {
        path: '',
        data: {
          pageTitle: 'asm.title',
          documentPageTitle: 'asm.title',
        },
        resolve: {pageData: PageDataResolver},
        canActivate: [AsmGuard],
        canActivateChild: [AsmGuard],
        loadChildren: () => import('./features/asm/pages/asm-routes').then((m) => m.asmRoutes),
      },
    ],
  },
  {
    path: 'covestro',
    data: {disableTopBar: true},
    resolve: {pageData: PageDataResolver},
    component: MainApplicationComponent,
    children: [
      {
        path: '',
        resolve: {pageData: PageDataResolver},
        loadChildren: () =>
          import('./features/covestro/pages/covestro-routes').then((m) => m.CovestroRoutes),
      },
    ],
  },
  {
    path: 'welcome',
    data: {pageTitle: 'welcome.title', documentPageTitle: 'welcome.title'},
    resolve: {pageData: PageDataResolver},
    component: PublicApplicationComponent,
    loadChildren: () =>
      import('./features/welcome/pages/welcome-routes').then((m) => m.welcomeRoutes),
  },
  {path: '**', redirectTo: WELCOME, pathMatch: 'full'},
];
